import StatusBadge from "../../intelligence/StatusBadge";
import {
  formatVehicleReviewStatus,
  vehicleReviewBadgeTone,
} from "../../../../constants/vehicleSourceConstants";

const VehicleReviewStatusBadge = ({ status }) => {
  if (!status) {
    return <span className="muted">—</span>;
  }

  return (
    <StatusBadge
      label={formatVehicleReviewStatus(status)}
      tone={vehicleReviewBadgeTone(status)}
    />
  );
};

export default VehicleReviewStatusBadge;
